import * as React from "react";
import { Global } from "@emotion/react";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { grey } from "@mui/material/colors";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Typography from "@mui/material/Typography";

const drawerBleeding = 56;

interface Props {
  window?: () => Window;
  open?: boolean;
  toggleDrawer?: Function;
  heading?: object;
  drawerData?: object;
  customClass?: string;
}

const Root = styled("div")(({ theme }) => ({
  height: "100%",
  backgroundColor: grey[100],
  ...theme.applyStyles("dark", {
    backgroundColor: theme.palette.background.default,
  }),
}));

const StyledBox = styled("div")(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.applyStyles("dark", {
    backgroundColor: grey[800],
  }),
}));

const Puller = styled("div")(({ theme }) => ({
  width: 30,
  height: 6,
  backgroundColor: grey[300],
  borderRadius: 3,
  position: "absolute",
  top: 8,
  left: "calc(50% - 15px)",
  ...theme.applyStyles("dark", {
    backgroundColor: grey[900],
  }),
}));

export default function MobileDrawer(props: Props) {
  const { open, toggleDrawer, customClass='' } = props;

  return (
    <Root>
      <CssBaseline />
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            height: `calc(70% - ${drawerBleeding}px)`,
            overflow: "visible",
          },
        }}
      />
      <SwipeableDrawer
        anchor="bottom"
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={false}
        ModalProps={{
          keepMounted: false,
        }}
        className={customClass}
      >
        <StyledBox
          sx={{
            position: "absolute",
            top: -drawerBleeding,
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            visibility: "visible",
            right: 0,
            left: 0,
            paddingTop: "26px",
          }}
          className="drawer-content-heading"
        >
          <Puller />
          {
            props?.heading && <Typography sx={{ p: 2 }}>{props?.heading}</Typography>
          }
        </StyledBox>
        <StyledBox
          sx={{ px: 2, pb: 2, mt: 4, height: "100%", overflow: "auto" }}
          className="drawer-content-wrap"
        >
          {props?.drawerData}
        </StyledBox>
      </SwipeableDrawer>
    </Root>
  );
}
